// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"AN-z","carouselContainer":"BN-z"};